import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@components/base_svg-icon/component';

import './styles.scss';

const FilterGroup = (props) => {
  const { title, children } = props;
  const [expanded, setExpanded] = useState(props.expanded || true);

  return (
    <div className={`filter-group ${expanded ? 'open' : 'closed'}`}>
      <div className="filter-group-header" onClick={() => setExpanded(!expanded)}>
        <a className="filter-group-id">{title}</a>
        <Icon name="ico-arrow-down"/>
      </div>
      <div className="collapsible-content">
        {!!expanded ? children : null }
      </div>
    </div>
  );
};

FilterGroup.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  expanded: PropTypes.bool,
  children: PropTypes.node,
};

export default FilterGroup;
